import { util } from '@pixum/std-lib';

/**
 * Returns the current URL's host and path as a single string.
 */
export function getCurrentHostAndPath(): string {
  const { host, path } = util.parseUrl();

  return host + path;
}
